import { useState } from "react";
import useUpdateCustomField from "./useUpdateCustomField";

const useEditCustomField = () => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedField, setSelectedField] = useState(null);
  const { updateCustomField } = useUpdateCustomField();
  const [dynamicFields, setDynamicFields] = useState([]);
  const [message, setMessage] = useState({ type: "", text: "" }); // State for success/error messages

  const handleOpenEditModal = (field) => {
    setSelectedField(field);
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setMessage({ type: "", text: "" }); // Clear message when closing the modal
  };

  const handleSubmitUpdateField = async (fieldId, payload) => {
    const result = await updateCustomField(fieldId, payload);

    if (result.success) {
      setMessage({ type: "success", text: result.message }); // Set success message
      setDynamicFields((prevFields) =>
        prevFields.map((field) =>
          field.id === fieldId ? { ...field, ...payload } : field
        )
      );
      setShowEditModal(false);
      window.location.reload();
    } else {
      setMessage({ type: "error", text: result.message }); // Set error message
    }
  };

  return {
    showEditModal,
    selectedField,
    handleOpenEditModal,
    handleCloseEditModal,
    handleSubmitUpdateField,
    message, // Return message state for use in the component
  };
};

export default useEditCustomField;
